<template>
  <div>
    <div v-if="!isAdmin" class="strongest-user">
      <div class="background-light"></div>
      <div
        v-if="isValentineDayEachGuard"
        class="strongest-all"
        @click="showStrongest"
      >
        <fps-avatar class="user-avatar" :src="masterInfo.strongest.avatarUrl" @click="showStrongest" />
        <fps-avatar class="user-avatar" :src="masterInfo.avatarUrl" @click="showStrongest" />
        <img
          v-if="avatarBorder"
          class="double-avatar-border"
          :src="'https://resource.funplus.social/user-static/31403.gif'"
          @click="showStrongest"
        />
      </div>
      <BorderAvatar
        class="strongest-user pointer"
        :borderMethod="borderMethod"
        @click.native="showStrongest"
        v-else
      >
        <fps-avatar
          v-if="masterInfo.strongest.userUuid"
          :src="masterInfo.strongest.avatarUrl"
        />
        <img
          v-else
          class="no-strongest"
          src="~@/assets/image/icons/no-strongest.png"
          @click="showStrongest"
        />
      </BorderAvatar>
    </div>
    <el-dialog
      v-if="!nativeType"
      v-show="!showSetStart"
      :visible.sync="showStrongestDialog"
      width="375px"
      :show-close="false"
      custom-class="dialog-clear-style strongest-dialog"
      @click.native="closeStrongestDialog"
      append-to-body
    >
      <div class="strongest-dialog-wrap" @click.stop="showHelpCircle = false">
        <fps-icon
          class="close-dialog pointer"
          type="close"
          size="24"
          color="#fff"
          @click.native="closeStrongestDialog"
        />
        <div v-if="masterInfo.strongest.eachGuard" class="strongest-all">
          <fps-avatar
            class="user-avatar"
            :src="masterInfo.strongest.avatarUrl"
          />
          <fps-avatar class="user-avatar" :src="masterInfo.avatarUrl" />
          <img
            v-if="avatarBorder"
            class="double-avatar-border"
            :src="
              isValentineDayEachGuard
                ? 'https://resource.funplus.social/user-static/31403.gif'
                : avatarBorder.guardEachImage
            "
            :style="{
              transform: `translate(-50%) scale(${
                isValentineDayEachGuard ? '1.4' : avatarBorder.guardEachRate
              })`
            }"
          />
        </div>
        <BorderAvatar
          v-else
          class="strongest-user"
          :borderMethod="borderMethod"
        >
          <fps-avatar
            v-if="masterInfo.strongest.userUuid"
            :src="masterInfo.strongest.avatarUrl"
          />
          <img
            v-else
            class="no-strongest"
            src="~@/assets/image/icons/no-strongest.png"
            @click="showStrongest"
          />
        </BorderAvatar>
        <div
          class="nickname"
          :class="masterInfo.strongest.userUuid && 'nickname-strongest'"
        >
          {{
            masterInfo.strongest.userUuid
              ? masterInfo.strongest.nickname
              : $t('components_photolist_index_1799')
          }}
        </div>
        <div class="need-score">
          <template v-if="masterInfo.strongest.userUuid">
            {{$t('components_photolist_index_1818',[masterInfo.strongest.sex === 'Female' ? $t('upgrade_page_views_master_index_216') : $t('app_1776')])}}
            <span>{{ masterInfo.strongest.score * diamondRatio }}</span>
          </template>
          <template v-else>{{$t('components_photolist_index_1800')}}<span>{{
              Math.ceil(masterInfo.strongest.guardMin * diamondRatio)
            }}</span>
          </template>
          <!-- <img src="~@/assets/image/icons/gold-icon.png" /> -->
          <img src="~@/assets/image/icons/diamond.png" />
        </div>
        <div class="jurisdic-title">
          <div class="line-left" />
          <span>{{$t('components_photolist_index_1801')}}</span>
          <div class="line-right" />
        </div>
        <div class="jurisdic-wrap">
          <div>
            <div class="img-wrap">
              <img src="~@/assets/image/icons/strongest-gray.png" />
            </div>
            <span>{{$t('components_photolist_index_1802')}}</span>
          </div>
          <div>
            <div class="img-wrap">
              <img src="~@/assets/image/icons/avatar-gray.png" />
            </div>
            <span>{{$t('components_photolist_index_1803')}}</span>
          </div>
          <div>
            <div class="img-wrap">
              <img src="~@/assets/image/icons/comment-gray.png" />
            </div>
            <span>{{$t('components_photolist_index_1804')}}</span>
          </div>
        </div>
        <div v-if="!isSelf" class="need-score-footer">
          <div v-if="!isActivity && masterInfo.strongest.needScore">{{$t('components_photolist_index_1805')}}<span>
              {{ Math.ceil(masterInfo.strongest.needScore * diamondRatio) }}
            </span>
            <!-- <img src="../../assets/image/icons/coin.png" /> -->
            <img src="~@/assets/image/icons/diamond.png" />
          </div>
          <div
            class="activity-box"
            v-if="isActivity && masterInfo.strongest.needScore"
          >
            <div class="price-box">
              <div>{{$t('components_photolist_index_1805')}}<span>
                  {{
                    Math.ceil(
                      masterInfo.strongest.needScore *
                        diamondRatio *
                        activityRatio
                    )
                  }}
                </span>
                <!-- <img src="../../assets/image/icons/coin.png"> -->
                <img src="~@/assets/image/icons/diamond.png" />
              </div>
              <div class="origin-price" v-if="isActivity">{{$t('upgrade_page_views_master_components_shouhu_dialog_2117')}}<span>
                  {{ Math.ceil(masterInfo.strongest.needScore * diamondRatio) }}
                </span>
                <!-- <img src="../../assets/image/icons/coin.png"> -->
                <img src="~@/assets/image/icons/diamond.png" />
              </div>
            </div>
            <img
              class="activity-icon"
              src="~@/assets/image/icons/activity-icon.png"
            />
          </div>
          <button class="know-btn" @click="closeStrongestDialog">{{$t('components_order_order_card_519')}}</button>
        </div>
        <div v-else class="need-score-footer">
          <button class="set-start-btn" @click="toSetStart">{{$t('components_photolist_index_1806')}}</button>
        </div>
        <div class="help-circle-container">
          <el-popover
            v-model="showHelpCircle"
            placement="right-start"
            trigger="click"
            popper-class="help-circle-wrap"
            @click.native.stop
          >
            <div slot="reference" class="help-circle pointer">
              <img src="~@/assets/image/icons/help-circle.png" />
            </div>
            <div class="content-wrap">
              <p class="stronger">{{$t('components_photolist_index_1807')}}</p>
              <template v-if="isSelf">
                <p>{{$t('components_photolist_index_1808')}}</p>
                <p>{{$t('components_photolist_index_1809')}}</p>
              </template>
              <template v-else>
                <p>{{$t('components_photolist_index_1810')}}</p>
                <p>{{$t('components_photolist_index_1811')}}</p>
              </template>
              <p>{{$t('components_photolist_index_1812')}}</p>
              <p>{{$t('components_photolist_index_1813')}}</p>
            </div>
          </el-popover>
        </div>
      </div>
    </el-dialog>
    <el-dialog
      :visible.sync="showSetStart"
      width="420px"
      :show-close="false"
      custom-class="dialog-clear-style strongest-dialog"
      append-to-body
    >
      <div class="strongest-dialog-wrap">
        <div class="start-title">
          <span>{{$t('components_photolist_index_1814')}}</span>
          <fps-icon
            class="close"
            type="close"
            color="#7a7a7a"
            size="24"
            @click.native="showSetStart = false"
          />
        </div>
        <div class="start-content">
          <div class="start-select">
            <el-popover
              placement="bottom"
              width="360"
              v-model="showSelectStart"
              class="select-unit"
              :visible-arrow="false"
              popper-class="popper-clear-style"
            >
              <div class="select-unit-wrap">
                <div
                  v-for="p in priceList"
                  :key="'price-' + p"
                  class="one-unit"
                  @click="selectStart(p)"
                >
                  <div class="price">
                    <img
                      v-if="p === 50"
                      class="border-img"
                      :src="borderList[0]"
                    />
                    <img
                      v-else-if="p === 150"
                      class="border-img"
                      :src="borderList[1]"
                    />
                    <img
                      v-else-if="p === 1000"
                      class="border-img"
                      :src="borderList[2]"
                    />
                    {{ Math.ceil(p * diamondRatio) }}
                    <img
                      class="gold-img"
                      src="~@/assets/image/icons/diamond.png"
                    />
                  </div>
                </div>
              </div>
              <div slot="reference" class="unit-button pointer">
                <span>{{ Math.ceil(guardMin * diamondRatio) }}</span>
                <img
                  :class="showSelectStart && 'active'"
                  src="~@/assets/image/icons/arrow-bottom-gray.png"
                />
              </div>
            </el-popover>
          </div>
          <div class="tool-btns">
            <button class="cancel-btn" @click="cancelSet">{{$t('upgrade_page_layout_header_42')}}</button>
            <button class="save-btn" @click="saveMin">{{$t('upgrade_page_views_dashboard_skills_skill_detail_1344')}}</button>
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import i18n from '@/locales/index'
import { mapGetters } from 'vuex';
import BorderAvatar from '@/components/FpsAvatar/border-avatar';

export default {
  name: 'ShouHuDialog',
  components: {
    BorderAvatar
  },
  props: {
    masterInfo: {
      type: Object,
      require: true
    }
  },
  data() {
    const priceList = [];
    let price = 50;
    while (price <= 10000) {
      priceList.push(price);
      price += 50;
    }
    return {
      showSetStart: false,
      guardMin: 50,
      priceList,
      showSelectStart: false,
      nativeType: this.$util.nativeType,
      length: 5,
      showStrongestDialog: false,
      showHelpCircle: false,
      diamondRatio: 15, //nicee币和钻石的比率
      activityRatio: 0.88 //nicee币和钻石的比率
    };
  },
  computed: {
    ...mapGetters(['userInfo', 'avatarBorder', 'adminUuid']),
    masterUuid() {
      return this.masterInfo.uuid || this.masterInfo.userUuid;
    },
    isAdmin() {
      return this.masterUuid == this.adminUuid;
    },
    borderList() {
      if (!this.avatarBorder) return [];
      return [
        this.avatarBorder.guardImageLevel1,
        this.avatarBorder.guardImageLevel2,
        this.avatarBorder.guardImageLevel3
      ];
    },
    isSelf() {
      return (
        this.masterInfo &&
        this.userInfo &&
        this.masterUuid === this.userInfo.uuid
      );
    },
    borderMethod() {
      if (!this.masterInfo) return 4;
      if (this.masterInfo.strongest.eachGuard) {
        return 3;
      }
      return this.masterInfo.strongest.guardLevel + 3;
    },
    // 是否開啓活動 開啓88折活動2023.03.18截止
    isActivity() {
      return new Date().getTime() < new Date('2023/03/18').getTime();
    },
    // 是否情人节头像框
    isValentineDayEachGuard() {
      try {
        return (
          this.masterInfo.strongest.eachGuard &&
          this.masterInfo.strongest.guardLevel === 4
        );
      } catch (error) {
        return false;
      }
    }
  },
  watch: {
    masterInfo(info) {
      if (info) {
        this.guardMin = info.strongest.guardMin || 50;
      }
    }
  },
  created() {
    this.guardMin = this.masterInfo.strongest.guardMin || 50;
  },
  methods: {
    toSetStart() {
      const guardMinTime = this.masterInfo.strongest.guardMinTime;
      if (
        !guardMinTime ||
        Date.now() - new Date(guardMinTime).getTime() > 30 * 24 * 60 * 60 * 1000
      ) {
        this.showSetStart = true;
      } else {
        this.$message(i18n.t('components_photolist_index_1815'));
      }
    },
    cancelSet() {
      this.showSetStart = false;
    },
    saveMin() {
      // 二次确认
      this.$confirm({
        content: i18n.t('components_photolist_index_1816'),
        confirmButtonText: i18n.t('upgrade_page_views_order_components_price_unit_305'),
        cancelButtonText: i18n.t('upgrade_page_layout_header_42')
      }).then(() => {
        // 設置初始價格
        this.$http
          .get('/user/setGuardMin', {
            min: this.guardMin
          })
          .then(() => {
            this.$message.success(i18n.t('upgrade_page_views_player_list_index_205'));
            const { strongest } = this.masterInfo;
            this.showSetStartStrongest = false;
            strongest.guardMin = this.guardMin;
            this.showSetStart = false;
            this.$store.dispatch('app/updateSomeOfViewMasterInfo', {
              strongest
            });
            this.$store.dispatch('app/getMasterInfo', {
              uuid: this.masterUuid
            });
          });
      });
    },
    selectStart(p) {
      this.guardMin = p;
      this.showSelectStart = false;
    },
    closeStrongestDialog() {
      this.showHelpCircle
        ? (this.showHelpCircle = false)
        : (this.showStrongestDialog = false);
    },
    showStrongest() {
      if (this.nativeType) {
        window.loadApp({
          title: i18n.t('upgrade_page_views_master_index_215', [this.masterInfo.nickname]),
          content: `${this.masterInfo.nickname}現在在線，使用app可以與${
            this.masterInfo.sex === 'Male' ? '他' : i18n.t('upgrade_page_views_master_index_216')
          }有更多互動喔！`,
          showCancelButton: false,
          showClose: true
        });
      } else {
        this.showStrongestDialog = true;
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.no-strongest {
  width: 100%;
  height: 100%;
}
.content-wrap {
  width: 300px;
  height: 100%;
  position: relative;
  z-index: 2;
}
.strongest-dialog-wrap {
  user-select: none;
  background: #ffffff;
  border-radius: 14px;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
  .close-dialog {
    width: 24px;
    position: absolute;
    top: 0px;
    right: -16px;
    transform: translate(100%);
  }
  .strongest-user {
    margin: -25px 0 17px;
    width: 48px;
    height: 48px;
  }
  .strongest-all {
    @include flex;
    height: 48px;
    position: relative;
    margin: -25px 0 27px;
    .user-avatar {
      width: 48px !important;
      height: 48px !important;
      &:first-child {
        margin-right: 0;
        position: relative;
        z-index: 2;
      }
    }
    .double-avatar-border {
      position: absolute;
      z-index: 2;
      top: 2px;
      left: 50%;
      height: 100%;
    }
  }
  .help-circle-container {
    position: absolute;
    top: 8px;
    right: 8px;
  }
  .nickname {
    font-weight: 500;
    font-size: 15px;
    line-height: 21px;
    color: $color-gray-3;
  }
  .nickname-strongest {
    color: #a962f0;
  }
  .need-score {
    display: flex;
    align-items: center;
    font-size: 13px;
    line-height: 18px;
    letter-spacing: -0.3px;
    margin-top: 6px;
    color: $color-gray-2;
    span {
      font-weight: 500;
      font-size: 14px;
      line-height: 17px;
      letter-spacing: -0.3px;
      color: $color-gray-1;
      margin: 0 2px;
    }
    img {
      width: 18px;
    }
  }
  .jurisdic-title {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 30px;
    span {
      margin: 0 20px;
      font-size: 12px;
      line-height: 17px;
      color: $color-gray-3;
      opacity: 0.8;
    }
    div {
      width: 100px;
      height: 2px;
    }
    .line-left {
      background: linear-gradient(
        270deg,
        #e8eaee 0%,
        rgba(232, 234, 238, 0) 100%
      );
    }
    .line-right {
      background: linear-gradient(
        90deg,
        #e8eaee 0%,
        rgba(232, 234, 238, 0) 100%
      );
    }
  }
  .jurisdic-wrap {
    width: 330px;
    margin: 0 auto;
    display: flex;
    margin-top: 24px;
    padding-bottom: 50px;
    & > div {
      flex: 1;
      display: flex;
      flex-direction: column;
      align-items: center;
      .img-wrap {
        width: 40px;
        height: 40px;
        border-radius: 50%;
        background: #f4f6f7;
        display: flex;
        justify-content: center;
        align-items: center;
        margin-bottom: 8px;
        img {
          width: 26px;
        }
      }
      span {
        font-size: 13px;
        line-height: 18px;
        text-align: center;
        color: $color-gray-2;
      }
    }
  }
  .need-score-footer {
    height: 66px;
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 16px;
    background: #ffffff;
    box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.05);
    border-radius: 14px;
    div {
      display: flex;
      font-size: 13px;
      line-height: 18px;
      text-align: center;
      letter-spacing: -0.3px;
      color: $color-gray-2;
      align-items: center;
      span {
        font-weight: 500;
        font-size: 14px;
        line-height: 18px;
        color: $color-gray-1;
        margin: 0 2px;
      }
      img {
        width: 18px;
      }
    }
    .know-btn {
      width: 164px;
      height: 44px;
      font-weight: 500;
      font-size: 16px;
      line-height: 44px;
      text-align: center;
      letter-spacing: -0.00032px;
      border-radius: 50px;
      background: $color-yellow;
      color: $color-gray-1;
    }
    .set-start-btn {
      width: 210px;
      height: 44px;
      border-radius: 40px;
      background: $color-yellow;
      font-weight: 500;
      font-size: 16px;
      line-height: 22px;
      color: $color-gray-1;
      margin: 0 auto;
    }
    .activity-box {
      align-items: flex-start;
      div {
        margin-left: 0;
      }
      .price-box {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        // justify-content: flex-start;
        margin-left: 0;
      }
      .origin-price {
        text-decoration: line-through;
      }
      .activity-icon {
        width: 50px;
        height: auto;
        margin-left: 10px;
      }
    }
  }
  .start-title {
    padding: 18px 18px 20px 30px;
    width: 100%;
    border-bottom: 1px solid #e0e0e0;
    font-weight: 500;
    font-size: 18px;
    line-height: 25px;
    color: $color-gray-1;
    @include flex(space-between);
  }
  .start-content {
    width: 100%;
    padding: 30px;
    .unit-button {
      height: 40px;
      background: #ffffff;
      border: 1px solid #999999;
      box-sizing: border-box;
      border-radius: 4px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 0 15px 0 9px;
      font-size: 14px;
      line-height: 20px;
      color: $color-gray-1;
      .no-unit {
        color: $color-gray-2;
      }
      img {
        width: 10px;
        transition: all 0.3s;
        &.active {
          transform: rotate(180deg);
        }
      }
    }
  }
  .tool-btns {
    display: flex;
    justify-content: flex-end;
    margin-top: 50px;
    button {
      width: 111px;
      height: 40px;
      border-radius: 40px;
      font-weight: 500;
      font-size: 14px;
      line-height: 20px;
    }
    .cancel-btn {
      margin-right: 8px;
      color: $color-gray-2;
      background: $color-button;
    }
    .save-btn {
      color: $color-gray-1;
      background: $color-yellow;
    }
  }
}
.select-unit-wrap {
  background: #fff;
  border-radius: 8px;
  filter: drop-shadow(0px 2px 24px rgba(0, 0, 0, 0.1));
  height: 390px;
  overflow-y: auto;
  @include hideScrollBar(2px, 0);
  .one-unit {
    cursor: pointer;
    font-weight: 500;
    font-size: 16px;
    height: 54px;
    margin: 0 18px;
    line-height: 54px;
    text-align: center;
    color: #333333;
    border-bottom: 1px solid $color-split;
    @include flex;
    .price {
      position: relative;
    }
    .gold-img {
      position: absolute;
      top: 50%;
      left: 100%;
      transform: translate(11px, -50%);
      width: 18px;
    }
    .border-img {
      position: absolute;
      top: 50%;
      right: 100%;
      transform: translate(-73px, -50%);
      width: 48px;
    }
    &:hover {
      background: #f6f6f6;
    }
  }
}
.help-circle {
  width: 24px;
  height: 24px;
  img {
    width: 100%;
  }
}
.strongest-user {
  width: 48px;
  height: 48px;
  .avatar-border {
    width: 100%;
  }
  .background-light {
    position: absolute;
    top: 50%;
    left: 50%;
    width: 102px;
    height: 102px;
    transform: translate(-50%, -50%);
    background: url('~@/assets/image/icons/background-light.png') no-repeat
      center center / 100%;
    pointer-events: none;
  }
  .strongest-all {
    display: flex;
    position: absolute;
    top: 50%;
    left: 50%;
    width: 150%;
    transform: translate(-50%, -50%);
    .double-avatar-border {
      position: absolute;
      width: 100%;
      transform: translate(0, 3px) scale(1.4);
    }
  }
}
</style>
